export default __webpack_public_path__ + "static/media/FAQ_13_2.90d7b015.png";